export default class PeriodsHelper {

  constructor() {}

  findPeriod(request, periods) {
    return periods.find(period => {
      return period.employeeId === request.employeeId &&
        period.enjoymentMonth === request.enjoymentMonth &&
        period.enjoymentDays === request.enjoymentDays;
    });
  }
}



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/common/domain/helpers/periodsHelper.js